<template>
  <section>
    <div class="input_container relative">
      <div class="flex justify-between">
        <label v-if="label" :for="label" class="block text-xs font-medium">
          {{ label }}
        </label>
        <span
          v-if="optional"
          class="text-sm text-gray-500 dark:text-gray-400"
          >{{ optional }}</span
        >
      </div>
      <div class="a relative mt-1 rounded-md shadow-sm">
        <div
          v-if="trailing"
          class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3"
        >
          <span class="text-gray-500 dark:text-gray-400 sm:text-sm">{{
            trailing
          }}</span>
        </div>
        <input
          :autocomplete="autocomplete"
          @input="updateValue"
          @change="updateValue"
          @blur="$emit('blur')"
          :disabled="disabled"
          :placeholder="placeholder"
          :type="visibled ? type : 'password'"
          :value="value"
          :class="[
            error
              ? 'border-ontick-red-500 border'
              : 'border-ontick-steel-300 dark:border-0',
            trailing ? 'px-8 ' : 'px-4',
          ]"
          class="focus:border-ontick-blue-600 dark:bg-ontick-carbon-500 dark:border-ontick-steel-500 block w-full appearance-none rounded-md py-2 text-gray-300 shadow-lg focus:outline-none dark:border sm:text-sm"
        />
        <div
          @click="visibled = !visibled"
          class="absolute inset-y-2 z-50 cursor-pointer text-gray-300 transition-all duration-150"
          :class="password_length > 0 || error ? 'right-12' : 'right-2'"
          v-html="visibled ? $icons.eye : $icons.eye_off"
        ></div>

        <div
          v-show="error"
          class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
        >
          <!-- Heroicon name: exclamation-circle -->
          <span class="text-ontick-red-500" v-html="$icons.error"></span>
        </div>
        <div
          :class="[
            {
              valid_password_length: valid_password_length,
              show_password_length: typed,
            },
            valid_password ? 'px-0 py-0' : ' px-2 py-0.5',
          ]"
          class="password_length"
        >
          <span v-show="!valid_password">{{ password_length }}</span>
          <span v-show="valid_password" v-html="$icons.check"></span>
        </div>
      </div>
      <p v-show="error" class="text-ontick-red-500 mt-1 text-xs">
        {{ error }}
      </p>
    </div>

    <div v-show="password_length > 0" class="lnu_container">
      <p :class="{ lovercase_valid: contains_lovercase }">Minúscula</p>
      <p :class="{ number_valid: contains_number }">Número</p>
      <p :class="{ uppercase_valid: contains_uppercase }">Maiúscula</p>
      <p :class="{ uppercase_valid: contains_special_character }">
        Caractere especial
      </p>
      <p :class="{ uppercase_valid: valid_password_length }">
        Quantidade minima
      </p>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      password: null,
      password_length: 0,
      typed: false,
      contains_lovercase: false,
      contains_number: false,
      contains_uppercase: false,
      contains_special_character: false,
      valid_password_length: false,
      valid_password: false,
      visibled: false,
    };
  },

  $_veeValidate: {
    name() {
      return this.name;
    },
    value() {
      return this.value;
    },
  },
  props: {
    value: String,
    bg: {
      type: String,
      default: "bg-ontick-steel-500",
    },
    name: {
      type: String,
    },
    label: {
      type: String,
    },
    placeholder: {
      type: String,
      default: "",
    },
    optional: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    trailing: {
      type: String,
      default: "",
    },
    error: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      default: "text",
      validator: (val) => {
        return (
          ["url", "text", "password", "email", "search"].indexOf(val) !== -1
        );
      },
    },
    autocomplete: {
      type: String,
    },
  },
  methods: {
    updateValue(e) {
      this.$emit("input", e.target.value);
      this.password = e.target.value;
      this.validate();
    },
    validate() {
      this.password_length = this.password.length;
      const format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

      if (this.password_length > 7) {
        this.valid_password_length = true;
      } else {
        this.valid_password_length = false;
      }

      if (this.password_length > 0) {
        this.typed = true;
      } else {
        this.typed = false;
      }

      this.contains_lovercase = /[a-z]/.test(this.password);
      this.contains_number = /\d/.test(this.password);
      this.contains_uppercase = /[A-Z]/.test(this.password);
      this.contains_special_character = format.test(this.password);

      // Check if the password is valid
      if (this.contains_lovercase == true && this.contains_number == true) {
        this.valid_password = false;
        if (
          this.contains_uppercase == true &&
          this.valid_password_length == true
        )
          this.valid_password = true;
        // this.$emit("validatePassword", this.password);
      } else {
        this.valid_password = false;
        // this.$emit("validatePassword", false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.password_length {
  position: absolute;
  top: 50%;
  right: 10px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  display: none;
  -webkit-transition: all 0.1s;
  transition: all 0.1s;
  @apply bg-ontick-blue-500 text-ontick-carbon-500 rounded-full text-sm;
}

.valid_password_length {
  @apply bg-ontick-green-500 text-ontick-carbon-500;
}

.show_password_length {
  display: block;
}

.lnu_container {
  @apply flex flex-wrap items-center space-x-2 py-3;
}

.lnu_container p {
  background: linear-gradient(to right, #19d684 50%, #2d3748 50%);
  background-size: 201% 100%;
  background-position: right;
  -webkit-transition: background 0.3s;
  transition: background 0.3s;
  @apply my-1 rounded-md px-2 text-center text-xs text-gray-400;
}

.lovercase_valid,
.number_valid,
.uppercase_valid {
  background-position: left !important;
  @apply text-ontick-carbon-500 font-medium #{!important};
}

.valid_password_container {
  display: block;
  margin: 10px auto;
  border-radius: 4px;
  position: relative;
  background: #00ad7c;
  width: 20px;
  height: 20px;
  visibility: hidden;
  opacity: 0;
}

.show_valid_password_container {
  visibility: visible;
  opacity: 1;
}

.tick {
  width: 100%;
  height: 100%;
  fill: none;
  stroke: white;
  stroke-width: 25;
  stroke-linecap: round;
  stroke-dasharray: 180;
  stroke-dashoffset: 180;
}

.checked {
  -webkit-animation: draw 0.5s ease forwards;
  animation: draw 0.5s ease forwards;
}

@keyframes draw {
  to {
    stroke-dashoffset: 0;
  }
}
</style>
